import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import { Ayuda } from "../context/AyudaContext";

function ModoSeguridad() {
  const [modo, setModo] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const cargarModo = () => {
    apiFetch("/api/modo-seguridad")
      .then((data) => setModo(data?.modo))
      .catch((err) => setError(err.message));
  };

  useEffect(() => {
    cargarModo();
  }, []);

  const cambiarModo = async (nuevoModo) => {
    const nombre = nuevoModo === "cloudflare" ? "Cloudflare" : "Nativo Servidor";
    if (!window.confirm(`¿Cambiar a modo ${nombre}? Esto recarga la configuración del servidor.`)) {
      return;
    }

    setCargando(true);
    setError("");
    setMensaje("");
    try {
      await apiFetch(`/api/modo-seguridad/${nuevoModo}`, { method: "POST" });
      setModo(nuevoModo);
      setMensaje("El modo se cambió correctamente.");
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: "0 auto" }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>🔒 Modo de Seguridad</h2>
      <Ayuda>
      <p style={{ color: "#64748b", marginBottom: 20, textAlign: "center" }}>
        Controla cómo llega el tráfico a compras.dsm.edu.ni: a través del proxy de Cloudflare
        (naranja), o directo al servidor (gris/DNS only).
      </p>
      </Ayuda>

      {mensaje && (
        <p style={{ color: "#16a34a", fontWeight: 600, marginBottom: 12 }}>{mensaje}</p>
      )}
      {error && <p style={{ color: "#dc2626", fontWeight: 600, marginBottom: 12 }}>{error}</p>}

      <div style={{ marginBottom: 16, fontWeight: 600 }}>
        Modo actual:{" "}
        {modo === "cloudflare"
          ? "🔵 Cloudflare"
          : modo === "nativo"
          ? "🖥️ Nativo Servidor"
          : "Cargando..."}
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button
          disabled={cargando || modo === "cloudflare"}
          onClick={() => cambiarModo("cloudflare")}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "none",
            background: modo === "cloudflare" ? "#93c5fd" : "#2563eb",
            color: "#fff",
            fontWeight: 600,
            cursor: modo === "cloudflare" ? "default" : "pointer",
          }}
        >
          🔵 Modo Cloudflare
        </button>

        <button
          disabled={cargando || modo === "nativo"}
          onClick={() => cambiarModo("nativo")}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "none",
            background: modo === "nativo" ? "#86efac" : "#16a34a",
            color: "#fff",
            fontWeight: 600,
            cursor: modo === "nativo" ? "default" : "pointer",
          }}
        >
          🖥️ Modo Nativo Servidor
        </button>
      </div>

      <Ayuda>
      <p style={{ color: "#94a3b8", fontSize: 13, marginTop: 20 }}>
        Usá "Cloudflare" cuando el registro DNS de compras esté en naranja (proxied) en Cloudflare.
        Usá "Nativo Servidor" cuando esté en gris (DNS only).
      </p>
      </Ayuda>
    </div>
  );
}

export default ModoSeguridad;
